import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from '../Modal.module.scss';

export type ModalBackdropProps = React.ComponentPropsWithRef<'div'>;

export const ModalBackdrop: React.ForwardRefExoticComponent<ModalBackdropProps> = React.forwardRef(
    ({ className, ...rest }, forwardedRef) => (
        <div
            {...rest}
            ref={forwardedRef}
            className={cx('modal-backdrop', styles.backdrop, className)}
        />
    ),
);

ModalBackdrop.displayName = 'ModalBackdrop';

ModalBackdrop.propTypes = {
    className: PropTypes.string,
};
